import axios from "axios";
import { getFromStorage, saveToStorage } from "utils/storage";
const baseURL = process.env.REACT_APP_API_URL;
export const refreshToken = async () => {
  // const history = useHistory();
  const refreshToken = getFromStorage("user_data")?.refresh_token;

  if (!refreshToken) throw new Error("No refresh token available");

  const response = await axios.post(baseURL + "User/RefreshSignIn", {
    refreshToken: refreshToken,
  });

  if (response?.data && response?.data?.data?.access_token) {
    return response?.data?.data;
  } else {
    window.location.href = "/login";
    throw new Error("Failed to refresh token");
  }
};
